<template>
	<v-layout row wrap>

		<financial-table-element
			lighten='0'
			xs='10'
			text='Suma wszystkich kosztów realizacji zadania'
		></financial-table-element>

		<financial-table-element
			lighten='0'
			xs='2'
			:text="formatMoney(totalAdministrative + totalActions)"
		></financial-table-element>

	</v-layout>
</template>
<script>
	import {Numbers} from "@/utils/Numbers";
  import FinancialTableElement from "@/view/logged/offer/components/FinancialTableRowElement";

	export default {
		name: "sumOfAll",

    components: {FinancialTableElement},

    props: {
			totalActions: {},
			totalAdministrative: {},
		},

		mixins: [Numbers],
	};
</script>
